var clickbounds = {
  jumbo__base: '88px',
  default__base: '48px',
  default__input: '56px',
  compact__standard: '32px',
  compact__input: '44px'
};

export { clickbounds };
